import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from 'react-router-dom';
import Home from './pages/Home/Home';
import React from 'react';
import { AppNavigationProvider } from './context/AppNavigationContext';
import { Paths } from './shared/constants';
import Projects from './pages/Projects/Projects';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Landing from './pages/InformationServices/Landing';
import Career from './pages/Career/CareersPage';
interface AppRouterProps {}
const AppRouter: React.FC<AppRouterProps> = (props: AppRouterProps) => {
  return (
    <Router>
      <AppNavigationProvider>
        <Routes>
          <Route path={Paths.home} element={<Home />} />
          <Route path={Paths.projects} element={<Projects />} />
          <Route path={Paths.policy} element={<PrivacyPolicy />} />
          <Route path={Paths.iss} element={<Landing />} />
          <Route path={Paths.career} element={<Career />} />
          <Route path={'*'} element={<Navigate to={Paths.home} />} />
        </Routes>
      </AppNavigationProvider>
    </Router>
  );
};
export default AppRouter;
